import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environment/environment';
import { Observable } from 'rxjs/internal/Observable';
import { LocalStorageService } from './local-storage-service';
@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private _http: HttpClient,
    private _localStorageService: LocalStorageService
  ) { }

  private getDepartmentFromLocalStorage(): string {
    return this._localStorageService.getItem('selectedDepartment');
  }

  createClientFolder(clientId: string): Observable<string> {
    const department = this.getDepartmentFromLocalStorage();

    const url = `${environment.api}/api/v1/documentbuilder/clients/${clientId}/createfolder?department=${department}`;

    return this._http.get(url, {
      responseType: 'text',
      headers: new HttpHeaders({
        'Accept': 'text/plain'
      })
    });
  }
}
